// partner-submission.component.ts

import { Component, OnInit, inject } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { PartnerService } from '../services/partner.service';
import { Partner } from '../interfaces/partner';
import { CommonModule } from '@angular/common';
import { PartnerFormComponent } from "../partner-form/partner-form.component";
@Component({
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, PartnerFormComponent],
  selector: 'app-partner-submission',
  templateUrl: './partner-submission.component.html',
  styleUrls: [
    './partner-submission.component.css',
    '../app.component.css'
  ]
})
export class PartnerSubmissionComponent {
  partnerService = inject(PartnerService)

  onPartnerFormSubmitted(partnerData: Partner) {
    this.partnerService.submitPartner(partnerData).subscribe({
      next: () => {
        //this.formReset();
        alert('Form submitted successfully!');
        window.location.reload();
      },
      error: (error: Error) => {
        console.error('Error submitting form:', error);
        alert('Something went wrong.');
      }
    });
  }
}
